export const PRIVILEGES = {
    AGENDA: 'AGENDA',
    ANIMALS: 'ANIMALS',
    CLUBS: 'CLUBS',
    PATIENTS: 'PATIENTS',
    ESTIMATION: 'ESTIMATION',
    BILL: 'BILL',
    ADMINISTRATION: 'ADMINISTRATION'
};